import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

export interface CatalogTableState {
  savedUrl: string | null;
}

const initialState: CatalogTableState = {
  savedUrl: null,
};

export const catalogTableSlice = createSlice({
  name: 'catalogTable',
  initialState,
  reducers: {
    setSavedUrl: (state, action: PayloadAction<string>) => {
      state.savedUrl = action.payload;
    },
  },
});

export const { setSavedUrl } = catalogTableSlice.actions;

export const selectCatalogTableState = (state: RootState) => state.catalogTable;

export default catalogTableSlice.reducer;